package pl.decks.chartjs.legend

import pl.decks.chartjs.model.JSEnum

@Suppress("unused")
enum class LegendPosition(override val jsValue: String) : JSEnum {
    Top("top"),
    Bottom("bottom"),
    Left("left"),
    Right("right"),
}